let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jvZ3l")).then(() => parcelRequire('2LYB4'));